// extracted by mini-css-extract-plugin
export default {"textEditor":"TextEditor_textEditor__VYziF","toolbar":"TextEditor_toolbar__+ZQU1","formatButton":"TextEditor_formatButton__5CkPX","textField":"TextEditor_textField__iG7jg"};